import * as React from "react";
import Autocomplete from "react-autocomplete";
import { FieldProps, StateProps } from "./props";
import api from "../../../api";
import "./autocomplete.scss";
import noImage from "../../../assets/images/user-noimage.png";
import { Lead, getLeadTitle, DateFormats } from "../../../core";
import { isObject } from "util";
import moment from "moment";

const LeadActivityAutoCompleteInput: React.FunctionComponent<FieldProps> = (
  props
) => {
  const [filteredItem, setFilteredItem] = React.useState<Lead[]>(
    props.list || []
  );

  const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
  const [showDropDown, setShowDropDown] = React.useState<boolean>(false);
  const [selectedItem, setSelectedItem] = React.useState<Lead | undefined>(
    props.defaultValue || undefined
  );

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  React.useEffect(() => {
    const id = isObject(props.defaultValue)
      ? props.defaultValue?._id
      : props.defaultValue;
    if (id && id !== selectedItem?._id) {
      setSelectedItem(props.list?.find((x) => x._id === id));
    }
  }, [props.defaultValue]);

  const clickDropDown = () => {
    setShowDropDown(!showDropDown);
  };

  const handleChange = (e: { target: any }) => {
    const { value } = e.target;
    if (value) {
      const items = props.list?.filter((x) => getLeadTitle(x)?.includes(value));
      setFilteredItem(items || []);
    } else {
      setFilteredItem(props.list || []);
    }
  };

  const handleSelect = (item: Lead) => {
    setSelectedItem(item);
    setShowDropDown(false);

    if (props.onChange != null) {
      props.onChange(item);
    }
  };

  const handleClickOutside = (event: { target: any }) => {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target)
    ) {
      setShowDropDown(false);
    }
  };

  return (
    <React.Fragment>
      {props.label && <label className={props.labelClass}>{props.label}</label>}
      {/* <div className="custom-dropdown position-relative" ref={wrapperRef}>
        <div
          onClick={clickDropDown}
          className="text-lg-left align-items-center border cursor-pointer custom-dropdown__value d-flex font-normal font-weight-semibold pb-3 pt-2 pt-3"
        >
          <div className="text-truncate">Add This Note To :</div>
          {selectedItem && props.defaultValue ? (
            <>
              <div className="flex-fill ml-1 text-muted ">
                {getLeadTitle(selectedItem)}
              </div>
              {selectedItem.isDeal ? (
                <div className="text-blue bg-gray-300 pl-2 pr-2 font-weight-light">
                  Opportunity
                </div>
              ) : (
                <div className="text-limegreen bg-gray-300 pl-2 pr-2 font-weight-light">
                  Lead
                </div>
              )}
            </>
          ) : (
            <div className="custom-dropdown__value-text flex-fill ml-1 text-muted text-truncate">
              LEAD / OPPORTUNITY
            </div>
          )}
        </div>
        {showDropDown && (
          <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100 position-absolute left-0 bg-white zIndex-2 pt-0">
            <div className="bg-white py-2 position-sticky top-0 zIndex-1">
              <div className="custom-dropdown__search border bg-gray-100 d-flex">
                <button
                  type="submit"
                  className="bg-transparent border-0 px-2 text-gray-600 d-flex align-items-center"
                >
                  <i className="icon-search"></i>
                </button>
                <input
                  type="text"
                  className="form-control bg-transparent border-0 py-0 px-1 font-weight-semibold font-normal"
                  placeholder="Search a Lead / Opportunity"
                  onChange={handleChange}
                  ref={(input) => input && input.focus()}
                />
              </div>
            </div>
            {filteredItem?.map((item) => {
              return (
                <LeadAutoFillItem
                  lead={item}
                  onClick={(lead) => handleSelect(lead)}
                ></LeadAutoFillItem>
              );
            })}
          </div>
        )}
      </div> */}
    </React.Fragment>
  );
};

export const LeadAutoFillItem = (props: {
  lead: Lead;
  onClick?: (item: Lead) => void;
}) => {
  const item = props.lead;
  return (
    <div
      onClick={() => props.onClick?.(item)}
      className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
    >
      <div className="font-normal font-weight-semibold text-lg-left w-100">
        {`${getLeadTitle(item)} - Created on ${moment(item.createdAt).format(
          DateFormats.NormalDateTimeFormat
        )} By ${item?.createdBy?.name || "Cityinfo website"}`}
      </div>
      {item.isDeal ? (
        <div className="text-blue font-weight-semibold bg-gray-200 pl-2 pr-2 font-sm">
          Opportunity
        </div>
      ) : (
        <div className="text-limegreen font-weight-semibold bg-gray-200 pl-2 pr-2 font-sm">
          Lead
        </div>
      )}
    </div>
  );
};

export default LeadActivityAutoCompleteInput;
